module.exports = __webpack_public_path__ + "img/trash_green.8586dbd0.svg";